import { ACCESS_USERID_KEY } from '@/constant/config';
import { request } from '@/utils/request';
import Storage from '@/utils/Storage';

/**
 * 提现记录查询
 * @returns
 */
export const getWhatsappInviteList = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/lb/get_whatsapp_invitelist',
    method: 'post',
    data: { userid }
  });
};

/**
 * 用户信息查询
 * @returns
 */
export const getWhatsappUserInfo = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/lb/get_whatsapp_userinfo',
    method: 'post',
    data: {
      userid
    }
  });
};

/**
 * 激活
 * @returns
 */
export const updateWhatsappStatus = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/lb/update_whatsapp_status',
    method: 'post',
    data: {
      userid
    }
  });
};

/**
 * 获取推荐用户列表
 * @returns
 */
export const getWhatsappRecommendList = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/lb/get_whatsapp_recommendusers',
    method: 'post',
    data: { userid }
  });
};
/**
 * @returns {Promise<RankResponse>} 获取跑马灯信息响应对象
 */
export const getCashoutHistoryList = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/lb/get_whatsapp_cashout_history',
    method: 'post',
    data: { userid }
  });
};
